var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/pinterest.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"-33.1 48.9 38.5 49.8\" class=\"c-social__pinterest\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title>\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-pinterest"])), env.opts.autoescape);
output += "\n    </title>\n\t<path d=\"M-12.6 48.9c-13.6 0-20.4 9.7-20.4 17.9 0 4.9 1.9 9.3 5.9 10.9.7.3 1.2 0 1.4-.7.1-.5.4-1.8.6-2.3.2-.7.1-1-.4-1.6-1.2-1.4-1.9-3.1-1.9-5.6 0-7.2 5.4-13.7 14.1-13.7 7.7 0 11.9 4.7 11.9 11C-1.5 73-5.2 80-10.6 80c-3 0-5.2-2.5-4.5-5.5.9-3.6 2.5-7.5 2.5-10.1 0-2.3-1.3-4.3-3.9-4.3-3.1 0-5.5 3.2-5.5 7.4 0 2.7.9 4.5.9 4.5s-3.1 13.3-3.7 15.6c-1.1 4.6-.2 10.3-.1 10.9 0 .3.5.4.7.2.3-.4 3.9-4.9 5.2-9.4.4-1.3 2-7.9 2-7.9 1 1.9 3.9 3.6 7 3.6 9.2 0 15.4-8.4 15.4-19.6.1-8.6-7.1-16.5-18-16.5z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/pinterest.j2"] , dependencies)